export const iconFontAwesomeSciencefictionBookJournalWhills = (
	<i className="fa-solid fa-book-journal-whills"></i>
);
